const Places = () => {
	return (
		<>
			<a
				target="_blank"
				aria-label="Google play"
				title="Google play"
				rel="noreferrer"
				href="https://music.apple.com/ua/album/madnotbad/1499960111?at=1001lwQy&ct=FFM_f9a19873486b90b05c431bd7a1a3af86&uo=4&app=itunes"
				className="services services__google_play"
			> </a>
			<a
				target="_blank"
				aria-label="Apple music"
				title="Apple music"
				rel="noreferrer"
				href="https://itunes.apple.com/us/artist/madnotbad/id1206245911"
				className="services services__apple_music"
			> </a>
			<a
				target="_blank"
				aria-label="Spotify"
				title="Spotify"
				rel="noreferrer"
				href="https://open.spotify.com/artist/2B2FpZFBuULtzNKbwnuSoG"
				className="services services__spotify"
			> </a>
			<a
				target="_blank"
				aria-label="Deezer"
				title="Deezer"
				rel="noreferrer"
				href="https://www.deezer.com/ru/artist/11955629"
				className="services services__deezer"
			> </a>
			<a
				target="_blank"
				aria-label="Youtube music"
				title="Youtube music"
				rel="noreferrer"
				href="https://music.youtube.com/channel/UC4y9xuoREXXoEvHiaAY4PoA"
				className="services services__youtube_music"
			> </a>
			<a
				target="_blank"
				aria-label="Soundcloud"
				title="Soundcloud"
				rel="noreferrer"
				href="https://soundcloud.com/madnotbad"
				className="services services__soundcloud"
			> </a>
		</>
	)
}

export default Places;